import Chip, { type ChipProps } from '@mui/material/Chip';
import { useRecordContext } from 'react-admin';

type Choice = { id: string; name: string };

// Labelled from the same choices list the filter and the Show page use, so the three agree.
const labelOf = (choices: Choice[], value: string) =>
  choices.find((c) => c.id === value)?.name ?? value;

export const StatusChip = ({
  choices,
  colors,
}: {
  choices: Choice[];
  colors: Record<string, ChipProps['color']>;
}) => {
  const record = useRecordContext();
  if (!record) return null;
  const status = record.status as string;
  return <Chip label={labelOf(choices, status)} color={colors[status] ?? 'default'} size="small" />;
};

export const ReasonChip = ({ choices }: { choices: Choice[] }) => {
  const record = useRecordContext();
  if (!record) return null;
  const reason = record.reason as string;
  return <Chip label={labelOf(choices, reason)} size="small" variant="outlined" />;
};
